import {Select, SelectItem, Input, DateRangePicker, SearchField} from "aria";
import moment from "moment";
import {useEffect, useState} from "react";
import {parseDate} from '@internationalized/date';

export function TypeFilter({column, table}) {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (value) column.setFilterValue([{key: column.id, operator: 'eq', value}])
    if (!value) column.setFilterValue([])
  }, [value]);

  return (
    <Select
      className={'w-full'}
      onSelectionChange={e => setValue(e)}
      placeholder={`tipo`}
      type="text"
      value={value}
    >
      <SelectItem id={''}>Todas</SelectItem>
      <SelectItem id={'topUp'}>Recarga</SelectItem>
      <SelectItem id={'topUpPackage'}>Paquete</SelectItem>
    </Select>
  )
}

export function ProviderFilter({column, table, options}) {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (value) column.setFilterValue([{key: column.id, operator: 'eq', value}])
    if (!value) column.setFilterValue([])
  }, [value]);

  return (
    <Select
      className={'w-full'}
      onSelectionChange={e => setValue(e)}
      placeholder={<span className={'text-nowrap'}>usuario TG</span>}
      type="text"
      value={value}
    >
      <SelectItem id={''}>Todos</SelectItem>
      {options.map(provider => (<SelectItem id={provider.user}>{provider.user}</SelectItem>
      ))}
    </Select>
  )
}

export function StatusFilter({column, table}) {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (value) column.setFilterValue([{key: column.id, operator: 'eq', value}])
    if (!value) column.setFilterValue([])
  }, [value]);

  return (
    <Select
      className={'w-full'}
      onSelectionChange={e => setValue(e)}
      placeholder={`Estado`}
      type="text"
      value={value}
    >
      <SelectItem id={''}>Todas</SelectItem>
      <SelectItem id={'SUCCESS'}>Exitosa</SelectItem>
      <SelectItem id={'ERROR'}>Error</SelectItem>
    </Select>
  )
}

export function ColumnFilter({column, table}) {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (value) column.setFilterValue([{key: column.id, operator: 'startsWith', value}])
    if (!value) column.setFilterValue([])
  }, [value]);

  return (
    <input
      className={'w-full h-10 px-2 border border-gray-600 rounded-md'}
      onChange={e => setValue(e.target.value)}
      onClick={e => e.stopPropagation()}
      placeholder={`Filtrar`}
      type="text"
    />
  )
}

export function DateTimeFilter({column, table}) {
  const [value, setValue] = useState({
    start: parseDate(moment().startOf('month').format('YYYY-MM-DD')),
    end: parseDate(moment().endOf('month').format('YYYY-MM-DD')),
  })

  const onChange = ({start, end}) => {
    setValue({start, end})
  }

  useEffect(() => {

    if (value) column.setFilterValue([
      {key: column.id, operator: 'gte', value: moment(value.start.toDate()).startOf('day')},
      {key: column.id, operator: 'lte', value: moment(value.end.toDate()).endOf('day')}
    ])

    if (!value) column.setFilterValue([])
  }, [value]);
  return (
    <DateRangePicker value={value} onChange={onChange}/>
  )
}